import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography, Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { ROUTE_ONBOARDING_DNA } from 'routes';
import Button from '../Common/Button';
import { UNKNOWN_RISK_COLOR } from 'colours';
import MockedDnaRiskExplanation from 'on_web/components/shared/DnaBasedRiskSummary/MockedDnaRiskExplanation';
import { trackEvent } from 'on_web/helpers/userTrackingEventsHelper';

/**
 * Component displaying summary for DNA based risk.
 *
 * @param {Component properties} props
 */
export default function MockedDnaBasedRiskSummary(props) {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <>
      <Grid
        container
        direction="row"
        justify={props.isDesktop ? 'space-around' : 'flex-start'}
        alignItems="flex-end"
        style={{ paddingTop: 20, paddingBottom: 20 }}
      >
        <Box mt={props.isDesktop ? 2 : 0}>
          <Typography
            style={{
              color: UNKNOWN_RISK_COLOR,
              fontFamily: 'MuseoSans-900',
              fontSize: 25,
              lineHeight: '30px',
            }}
          >
            {t('reporting.myAssessment.dnaBasedRisksSubtitle')}
          </Typography>
          <Box mt={2}>
            <Typography
              style={{
                fontSize: '15px',
                lineHeight: '20px',
                fontWeight: 'bold',
              }}
            >
              {t('reporting.common.buy.paragraph1')}
            </Typography>
          </Box>
          {props.showButton && props.productData && (
            <>
              <Box mt={2} display="flex" justifyContent={'center'}>
                <Typography
                  style={{
                    fontSize: '18px',
                    lineHeight: '20px',
                    fontWeight: 'bold',
                  }}
                >
                  {t('reporting.common.buy.limitedTimeOffer')}
                </Typography>
              </Box>

              <Box mt={2} display="flex" justifyContent={'center'}>
                <Typography
                  style={{
                    color: UNKNOWN_RISK_COLOR,
                    fontSize: '25px',
                    lineHeight: '20px',
                    fontWeight: 'bold',
                  }}
                >
                  {'$'}
                  {props.productData.price}
                </Typography>
              </Box>

              <Box mt={2} display="flex" justifyContent={'center'}>
                <Typography
                  style={{
                    fontSize: '14px',
                    lineHeight: '20px',
                    fontWeight: 'bold',
                  }}
                >
                  {t('reporting.common.buy.regular')}{' '}
                  <span style={{ textDecoration: 'line-through' }}>
                    {t('reporting.common.buy.regularPrice')}
                  </span>
                </Typography>
              </Box>

              <Box mt={2} display="flex" justifyContent={'center'}>
                <Button
                  style={{ fontSize: '14px', marginTop: '8px' }}
                  variant="containedPrimary"
                  outlinedColor="black"
                  width="194px"
                  onClick={() => {
                    trackEvent(
                      'Start PURCHASE',
                      'User clicked on start purchase'
                    );
                    history.push(ROUTE_ONBOARDING_DNA);
                  }}
                >
                  {t('reporting.common.buy.buttonText')}
                </Button>
              </Box>
            </>
          )}
          {props.isDesktop && (
            <MockedDnaRiskExplanation isDesktop={props.isDesktop} />
          )}
        </Box>
      </Grid>
    </>
  );
}

MockedDnaBasedRiskSummary.propTypes = {
  /**
   * Indicates Desktop resolution.
   */
  isDesktop: PropTypes.bool.isRequired,
};
